<!-- <div class="d-block text-center"> -->
  <button
  *ngIf="showCloseIcon"
  type="button"
  class="close-modal"
  (click)="handleCloseClick()" 
>
  <span class="icon-cross-small"></span>
</button>
<!-- <div class=""> -->
<div class="otp_title " *ngIf="showMesgOtpSendToMobile && !(title && message)">
    <span for="" [innerHTML]="showMesgOtpSendToMobile"></span>
</div>
<div *ngIf="!showMesgOtpSendToMobile && (title || message)" class="mt-4">
    <h3 class="text-primary text-center" *ngIf="title" [innerHTML]="title"></h3>
    <p class="text-primary text-center otp_message" *ngIf="message" [innerHTML]="message"></p>
</div>
<!-- </div> -->
<div class="text-center mt-3" #inputDiv>
  <ng-container *ngIf="!otpBoxNormal; else singleInput">
    <div class="otp-inputs">
      <input
        *ngFor="let control of code.controls; let i = index; let isLast = last; let isFirst = first"
        type="text"
        class="digit mx-10"
        appOtpMask
        [maskChar]="'*'"
        [ngClass]="{ isFirst: isFirst }"
        appFocusToNextInput
        [focusAfterLastInput]="isLast && !isSubmitBtn ? undefined : '#verifyOtpBtn'"
        maxlength="1"
        (keypress)="numberOnly($event, isLast && !isSubmitBtn)"
        [formControl]="getket(i)"
        (input)="onOtpInputChange()" 
      />
    </div>
  </ng-container>
  

  <ng-template #singleInput>
    <input
      type="text"
      appOtpMask
      [maskChar]="'*'"
      class="singleInput form-control isFirst text-center"
      [appInputRestriction]="'integer'"
      [placeholder]="placeholder"
      [formControl]="normalOtpInp"
      [maxlength]="otpBox"
      (keyup)="normalOtpInp.updateValueAndValidity()"
      (keyup.enter)="otpBoxNormal == false ? !code.valid : !normalOtpInp.valid ? false : checkit()"
    />
  </ng-template>
  
</div>

<p class="text-center mt-2" *ngIf="isResendOTP">
  <span class="" [style.minWidth]="'max-content'" [style.width.px]="">
    <p class="m-0" *ngIf="count">Resend again in {{ count }} second</p>
    <p class="m-0" *ngIf="!count">
      Didn’t Receive OTP
      <a
        href="javascript:void(0)"
        class="text-primary"
        (click)="resendOtpFn(true)"
        >{{ isResendText }}</a
      >
    </p>
  </span>
</p>

<div class="text-center text-gray mt-2 pl-2" *ngIf="onlyMessage">
  <span
    class="text-center"
    [style.minWidth]="'max-content'"
    [style.width.px]="40 * otpBox + 15"
  >
    <p class="text-gray" *ngIf="count">OTP will expire in {{ count }} second</p>
  </span>
</div>

<div class="text-center" *ngIf="isSubmitBtn">
  <button
  type="button"
  class="w-50"
  [disabled]="otpBoxNormal ? !normalOtpInp.valid : !code.valid"
  (click)="checkit()"
  [class]="submitBtnClass"
  id="verifyOtpBtn"
  >
    {{ submitBtnName }}
  </button>
</div>
<ng-content></ng-content>
<!-- </div> -->

<!-- <input type="text" class="digit mx-10" appValidComm maxlength="1" (keypress)="numberOnly($event)" *ngFor="let control of code.controls; index as i" [formControl]="getket(i)"> -->
